import { render, staticRenderFns } from "./CallCentreClientData.vue?vue&type=template&id=39798e33&scoped=true"
import script from "./CallCentreClientData.vue?vue&type=script&lang=ts"
export * from "./CallCentreClientData.vue?vue&type=script&lang=ts"
import style0 from "./CallCentreClientData.vue?vue&type=style&index=0&id=39798e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39798e33",
  null
  
)

export default component.exports